import React from 'react';

import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';

import { Td } from '../../ratePlans/components/css';

const VehicleInfoListRow = ({ row, rowIndex, vehicleInfo, setVehicleInfo }) => {
  const { vin, make, model, year, quantity } = row;

  const removeVehicleInfo = () => {
    const newVehicleInfo = [...vehicleInfo];
    newVehicleInfo.splice(rowIndex, 1);
    setVehicleInfo(newVehicleInfo);
  };

  return (
    <tr>
      <Td style={{ background: !vin ? '#f4f4f4' : '#ffffff' }}>{vin}</Td>
      <Td style={{ background: !make ? '#f4f4f4' : '#ffffff' }}>{make}</Td>
      <Td style={{ background: !model ? '#f4f4f4' : '#ffffff' }}>{model}</Td>
      <Td style={{ background: !year ? '#f4f4f4' : '#ffffff' }}>{year}</Td>
      <Td>{quantity}</Td>
      <Td>
        <div style={{ cursor: 'pointer' }}>
          <Button
            icon={Delete}
            onPress={removeVehicleInfo}
            accessibilityLabel="Delete"
            variant={{ text: true }}
          />
        </div>
      </Td>
    </tr>
  );
};

VehicleInfoListRow.propTypes = {
  row: PropTypes.shape({
    vin: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.number,
    quantity: PropTypes.number
  }).isRequired,
  rowIndex: PropTypes.number.isRequired,
  vehicleInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
  setVehicleInfo: PropTypes.func.isRequired
};

export default VehicleInfoListRow;
